import styled from 'styled-components';
import finchLogo from 'assets/img/finchLogo.svg';
import { BaseAvatar } from './BaseAvatar';

const StyledAvatar = styled(BaseAvatar)`
  background-color: transparent;
`;

export const FinchAvatar = () => {
  return (
    <StyledAvatar>
      <img src={finchLogo} alt="Finch logo" />
    </StyledAvatar>
  );
};
